import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { GetMedicineSubgroupResponse } from '../../responses/pharmacy/get-medicine-subgroup.response';
import { ListMedicineSubgroupResponse } from '../../responses/pharmacy/list-medicine-subgroup.response';
import { MedicineSubgroupModel } from '../../models/pharmacy/medicine-subgroup.model';
import { MedicineSubgroupRequest } from '../../requests/pharmacy/medicine-subgroup.request';

@Injectable({
  providedIn: 'root'
})
export class MedicineSubgroupService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public getMedicineSubgroup(idMedicineSubgroup: number): Observable<GetMedicineSubgroupResponse>{
    let uri = `MedicineSubgroup/idMedicineSubgroup/${idMedicineSubgroup}`;

    return this.httpClient.get<GetMedicineSubgroupResponse>(environment.urlApiPharmacy + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public listMedicineSubgroup(searchText: string): Observable<ListMedicineSubgroupResponse> {
    
    let uri = 'MedicineSubgroup?'
    
    if(searchText != null)
      uri = uri+ `searchText=${searchText}&`;
    
    return this.httpClient.get<ListMedicineSubgroupResponse>(environment.urlApiPharmacy + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public listAllMedicineSubgroup(): Observable<ListMedicineSubgroupResponse> {
    let uri = 'MedicineSubgroup/getAll'
    
    return this.httpClient.get<ListMedicineSubgroupResponse>(environment.urlApiPharmacy + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public createMedicineSubgroup(body: MedicineSubgroupRequest): Observable<ReturnStruct>{

    let uri = `MedicineSubgroup`

    return this.httpClient.post<ReturnStruct>(environment.urlApiPharmacy + uri, body, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public updateMedicineSubgroup(idMedicineSubgroup: number, body: MedicineSubgroupRequest): Observable<ReturnStruct>{

    let uri = `MedicineSubgroup/idMedicineSubgroup/${idMedicineSubgroup}`

    return this.httpClient.put<ReturnStruct>(environment.urlApiPharmacy + uri, body, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public deleteMedicineSubgroup(idMedicineSubgroup: number): Observable<ReturnStruct>{

    let uri = `MedicineSubgroup/idMedicineSubgroup/${idMedicineSubgroup}`

    return this.httpClient.delete<ReturnStruct>(environment.urlApiPharmacy + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
